import Swiper from 'swiper/bundle';

export default function  initializeGallerySlider(){
  if(document.querySelector('.block-gallery-slider__swiper')) {
    let swiper = new Swiper( ".block-gallery-slider__swiper", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      speed: 1300,
      loop: false,
      freeMode: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
}